module.exports = __webpack_public_path__ + "img/+.7ed9fb72.svg";